export default class {
    _id;
    _client;
    _note;
    _createdOn;
    _mailsCount;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get client() {
        return this._client
    }

    set client(value) {
        this._client = value
    }

    get note() {
        return this._note
    }

    set note(value) {
        this._note = value
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get mailsCount() {
        return this._mailsCount;
    }

    set mailsCount(value) {
        this._mailsCount = value;
    }
}
